import { FormSelect } from '@core/components/form';
import { FormGroup } from '@core/utils/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import React, { memo, useCallback, useMemo } from 'react';
import { Col, Row } from 'reactstrap';

export interface FormDurationProps {
  form: FormGroup<any>;
}

export const FormDuration = memo((props: FormDurationProps) => {
  const { form } = props;
  const formValue = useObservable(form.value$);

  const setTime = useCallback(
    (type: string, inValue: number) => {
      let value = inValue;
      if (type == 'hours') {
        value = value * 60;
      } else if (type == 'days') {
        value = value * 60 * 24;
      }
      form.controls.time_before_event.setValue(value);
    },
    [form.controls.time_before_event],
  );
  const durationValues = useMemo(() => {
    if (formValue.type == 'minutes') {
      return [15, 30, 45].map(value => ({ label: value.toString(), value }));
    } else if (formValue.type == 'hours') {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].map(value => ({ label: value.toString(), value }));
    } else {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31].map(value => ({
        label: value.toString(),
        value,
      }));
    }
  }, [formValue.type]);

  return (
    <Row>
      <Col>
        <FormSelect
          control={form.controls.type}
          onChange={value => {
            if (value == 'minutes') {
              form.controls.value.setValue(15);
              setTime('minutes', 15);
            } else if (value == 'hours') {
              form.controls.value.setValue(1);
              setTime('hours', 1);
            } else if (value == 'days') {
              form.controls.value.setValue(1);
              setTime('days', 1);
            }
          }}
          items={[
            { label: 'Minutes', value: 'minutes' },
            { label: 'Hours', value: 'hours' },
            { label: 'Days', value: 'days' },
          ]}
        />
      </Col>
      <Col>
        <FormSelect control={form.controls.value} items={durationValues} onChange={value => setTime(formValue.type, value!)} />
      </Col>
    </Row>
  );
});
